import React from 'react';
import { Tag } from 'antd';
import styled from '@emotion/styled';
import { toSubscriptionDuration } from '../../../../utils/transfer/access-code';
import { appStyles } from '../../../../styles';

interface SubscriptionDurationColumnProps {
  value: number;
}

export default React.memo((props: SubscriptionDurationColumnProps) => {
  return (
    <StyledContainer>
      <Tag color="#EEEEEE" className="default">
        {`${toSubscriptionDuration(Number(props.value))} (${props.value} month)`}
      </Tag>
    </StyledContainer>
  );
});

const StyledContainer = styled.div`
  .ant-tag {
    width: 160px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    border-radius: 0;
    font-size: 14px;
    &.default {
      ${appStyles.color.black}
    }
  }
`;
